export const CUSTOMER_DEPOSIT_PERMISSION = {
  VIEW: 'CUSTOMER_DEPOSIT_VIEW',
};
